module.exports = __webpack_public_path__ + "static/EnmTX_BosTenguEagle_L_A_cl-5adf4a80001cef4b06c648297d13e886.gif";